import { render, staticRenderFns } from "./TabelaPercentual.vue?vue&type=template&id=30ebd135&scoped=true"
import script from "./TabelaPercentual.vue?vue&type=script&lang=js"
export * from "./TabelaPercentual.vue?vue&type=script&lang=js"
import style0 from "./TabelaPercentual.vue?vue&type=style&index=0&id=30ebd135&prod&lang=css"
import style1 from "./TabelaPercentual.vue?vue&type=style&index=1&id=30ebd135&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ebd135",
  null
  
)

export default component.exports